import React from 'react';
import CampaignsSelect from './CampaignsSelect';
import PostsList from './PostsList';
import Filters from './Filters';
import {
    DeleteDialog,
    RejectDialog,
    LogsDialog,
    PublishDialog,
    EditDialog
} from 'dash-front/campaign/containers/Campaign/dialogs';
import * as rmd from 'material-ui';

const Hub = () => (
    <div style={{ display: 'flex', paddingTop: 20, width: '100%', marginBottom: 50 }}>
        <div style={{ width: 240, minWidth: 240, marginRight: 37 }}>
            <rmd.Paper>
                <Filters />
            </rmd.Paper>
        </div>
        <div style={{ width: 'calc(100% - 277px)' }}>
            <rmd.Paper>
                <PostsList />
            </rmd.Paper>
        </div>

        <PublishDialog />
        <EditDialog />
        <LogsDialog />
        <RejectDialog />
        <DeleteDialog />
    </div>
);

export default Hub;



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Hub/index.js
 **/